import get from 'lodash/get';

export default content => ({
  title: get(content, 'title.label', ''),
  titleColor: get(content, 'title.color', ''),
  titleHtmlTag: get(content, 'title.htmlTag', ''),
  subtitle: get(content, 'subtitle', ''),
  data: get(content, 'thematics', [])
});
